import { z } from 'zod';

const optionalEmail = z
  .string()
  .email('Bitte eine gültige E-Mail-Adresse eingeben.')
  .optional()
  .or(z.literal(''));

export const customerSchema = z.object({
  companyName: z.string().min(2, 'Bitte den Firmennamen eingeben.').max(160),
  billingAddress: z.string().max(300).optional().or(z.literal('')),
  email: optionalEmail,
  phone: z.string().max(40).optional().or(z.literal('')),
  notes: z.string().max(2000).optional().or(z.literal('')),
});
export type CustomerFormValues = z.infer<typeof customerSchema>;

export const contactSchema = z.object({
  name: z.string().min(2, 'Bitte den Namen eingeben.').max(120),
  email: optionalEmail,
  phone: z.string().max(40).optional().or(z.literal('')),
  approvalAuthorized: z.boolean().optional(),
});
export type ContactFormValues = z.infer<typeof contactSchema>;
